import React, { useState } from 'react';
import DarkInput from '../components/DarkInput';
import GradientButton from '../components/GradientButton';
import ErrorBanner from '../components/ErrorBanner';
import { login } from '../api';

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const token = await login(username, password);
      localStorage.setItem('token', token);
      onLogin();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: '#08090d' }}>

      {/* Subtle background glow */}
      <div style={{
        position: 'fixed', top: '20%', left: '50%', transform: 'translateX(-50%)',
        width: '600px', height: '300px', borderRadius: '50%',
        background: 'radial-gradient(ellipse, rgba(59,130,246,0.06) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      <div className="w-full" style={{ maxWidth: '400px' }}>

        {/* Logo mark */}
        <div className="flex flex-col items-center mb-8">
          <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4"
            style={{ background: 'linear-gradient(135deg, #3b82f6 0%, #6366f1 100%)', boxShadow: '0 0 32px rgba(99,102,241,0.3)' }}>
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24">
              <ellipse cx="12" cy="5" rx="9" ry="3" />
              <path d="M3 5v4c0 1.657 4.03 3 9 3s9-1.343 9-3V5" />
              <path d="M3 9v4c0 1.657 4.03 3 9 3s9-1.343 9-3V9" />
              <path d="M3 13v4c0 1.657 4.03 3 9 3s9-1.343 9-3v-4" />
            </svg>
          </div>
          <h1 className="text-xl font-semibold text-gray-100">Prebuilt Queries</h1>
          <p className="text-sm mt-1" style={{ color: '#6b7280' }}>Admin Console</p>
        </div>

        {/* Card */}
        <div className="rounded-2xl border p-8" style={{ backgroundColor: '#0f1117', borderColor: '#1e2130', boxShadow: '0 24px 48px rgba(0,0,0,0.4)' }}>

          <h2 className="text-base font-semibold text-gray-100 mb-6">Sign in to your account</h2>

          {error && <div className="mb-5"><ErrorBanner message={error} /></div>}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-xs font-medium mb-2" style={{ color: '#9ca3af' }}>Username</label>
              <DarkInput
                type="text"
                value={username}
                onChange={e => setUsername(e.target.value)}
                placeholder="Enter your username or email"
                required
                style={{ width: '100%', padding: '10px 14px', fontSize: '14px' }}
              />
            </div>
            <div>
              <label className="block text-xs font-medium mb-2" style={{ color: '#9ca3af' }}>Password</label>
              <DarkInput
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                style={{ width: '100%', padding: '10px 14px', fontSize: '14px' }}
              />
            </div>
            <GradientButton
              type="submit"
              disabled={loading}
              style={{ width: '100%', justifyContent: 'center', padding: '10px 0', marginTop: '4px' }}
            >
              {loading ? (
                <>
                  <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                  </svg>
                  Signing in...
                </>
              ) : 'Sign in'}
            </GradientButton>
          </form>
        </div>
      </div>
    </div>
  );
}
